module.exports = __webpack_public_path__ + "img/2.f20d4c3c.jpg";